import * as React from "react";
import { MenuItem, Select, FormControl } from "@mui/material";
import { useLocation } from "react-router-dom";

export default function Dropdown({
  doctype,
  setdoctype,
  disabled,
  setdocument_data,
}: any) {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);

  let querySection = queryParams.get("section");
  React.useEffect(() => {
    if (querySection) {
      if (querySection == "Generate Acceptance Criteria ") {
        querySection = "Generate Acceptance Criteria & Expected Results";
      }
      setdoctype(querySection);
    }
    if (querySection) {
      if (querySection == "Generate End to End Traceability") {
        querySection = "End to End Traceability";
      }
      setdoctype(querySection);
    }
  }, []);
  const doctypes = [
    "Generate Feature Needs with Rationale",
    "Generate Use cases",
    "Generate Feature Requirements with Rationale",
    "Generate User Stories",
    "Generate Test Case Steps",
    "Generate Acceptance Criteria & Expected Results",
  ];

  const doctypesDisplay: any = {
    "Generate Feature Needs with Rationale":
      "Generate Feature Needs with Rationale",
    "Generate Use cases": "Generate Use Cases",
    "Generate Feature Requirements with Rationale":
      "Generate Feature Requirements with Rationale",
    "Generate User Stories": "Generate User Stories",
    "Generate Test Case Steps": "Generate Test Case Steps",
    "Generate Acceptance Criteria & Expected Results":
      "Generate Acceptance Criteria & Expected Results",
  };

  const handleChange = (event: any) => {
    setdoctype(event.target.value);
    setdocument_data([]);
  };

  return (
    <div>
      <FormControl sx={{ width: "25rem" }}>
        <Select
          sx={{ fontSize: "1rem", fontWeight: "bolder" }}
          value={doctype}
          disabled={disabled}
          onChange={handleChange}
          displayEmpty
          renderValue={(selected) => {
            if (selected === "") {
              return "Select a Document Type...";
            }
            return selected;
          }}
        >
          {doctypes.map((type) => (
            <MenuItem
              sx={{ fontSize: "1rem", fontWeight: "bolder" }}
              key={type}
              value={type}
            >
              {doctypesDisplay[type as any] || type}{" "}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
